import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

const projects = [
  {
    n: "01",
    name: "K9 Transform",
    type: "Site sur-mesure — Éducation canine",
    description:
      "Site moderne pour un éducateur canin — réservation en ligne et programmes détaillés.",
    location: "Tarn (81)",
    url: "https://k9-transform.preview.emergentagent.com",
    image:
      "https://images.unsplash.com/photo-1503256207526-0d5d80fa2f47?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwxfHxkb2clMjB0cmFpbmluZ3xlbnwwfHx8fDE3ODE2MTQwNDF8MA&ixlib=rb-4.1.0&q=85",
    imageAlt: "Chien berger d'éducation canine — projet K9 Transform par WebUP Tarn",
  },
  {
    n: "02",
    name: "Carrosserie Pelras",
    type: "Refonte premium — Carrosserie locale",
    description:
      "Refonte complète : identité forte, galerie, devis et SEO local.",
    location: "Marssac-sur-Tarn (81)",
    url: "https://carrosserie-premium.preview.emergentagent.com",
    image:
      "https://images.unsplash.com/photo-1591278169757-deac26e49555?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwxfHxjYXIlMjBib2R5JTIwc2hvcHxlbnwwfHx8fDE3ODE2MTQwNTN8MA&ixlib=rb-4.1.0&q=85",
    imageAlt: "Atelier de carrosserie — refonte site Carrosserie Pelras Marssac-sur-Tarn par WebUP",
  },
];

export const Portfolio = () => (
  <section id="realisations" data-testid="portfolio-section" className="py-24 md:py-32 bg-paper">
    <div className="max-w-7xl mx-auto px-6 md:px-10">
      <div className="mb-16 grid grid-cols-1 lg:grid-cols-12 gap-12 items-end">
        <div className="lg:col-span-7">
          <p className="font-mono-label text-ink/60"><span className="rule" />Réalisations</p>
          <h2 className="mt-6 font-display text-4xl sm:text-5xl lg:text-6xl text-ink tracking-tight leading-[1.05]">
            Quelques projets <em className="italic font-light">menés dans le Tarn</em>.
          </h2>
        </div>
        <p className="lg:col-span-4 text-ink/65 leading-relaxed">
          Une sélection récente — chacun avec ses enjeux SEO et conversion.
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-10">
        {projects.map((p, i) => (
          <motion.a
            key={p.name}
            href={p.url}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={`portfolio-${i}`}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-50px" }}
            transition={{ duration: 0.6, delay: i * 0.1 }}
            className="group block bg-white border border-ink/10 overflow-hidden hover:-translate-y-1 transition-transform duration-500"
          >
            <div className="aspect-[4/3] overflow-hidden bg-paper-soft">
              <img
                src={p.image}
                alt={p.imageAlt || p.name}
                title={p.name}
                width="800"
                height="600"
                loading="lazy"
                decoding="async"
                className="h-full w-full object-cover group-hover:scale-[1.03] transition-transform duration-700"
              />
            </div>
            <div className="p-8 md:p-10">
              <div className="flex items-start justify-between gap-4">
                <div>
                  <p className="font-mono-label text-ink/50">{p.n} — {p.location}</p>
                  <h3 className="mt-3 font-display text-3xl text-ink">{p.name}</h3>
                  <p className="mt-1 text-sm text-ink/60">{p.type}</p>
                </div>
                <ArrowUpRight size={22} className="text-ink/60 group-hover:-translate-y-1 group-hover:translate-x-1 transition-transform" />
              </div>
              <p className="mt-5 text-ink/70 leading-relaxed text-[15px]">{p.description}</p>
              <p className="mt-6 text-xs text-ink/55 break-all link-under inline-block">{p.url.replace(/^https?:\/\//, "")}</p>
            </div>
          </motion.a>
        ))}
      </div>
    </div>
  </section>
);
